module.exports = __webpack_public_path__ + "img/phone.a8ec66fb.svg";